<template>
  <div class="batch-samples">
    <md-button
      class="btn btn-nonenary"
      :disabled="isDisabled"
      @click="handleBatchSelectedSamples"
    >
      <md-icon md-src="/static/images/icon-batch-sample.svg" />

      Lotear amostras
    </md-button>

    <modal
      ref="batchesModal"
      template="neutral"
      ref-name="batchesModal"
      :title="title"
      :icon-enabled="false"
      :close-button-enabled="true"
      @close="resetModalParams"
    >
      <batch-samples-sample-details
        v-if="step === ModalToBatchSamplesStep.SampleDetails && detailedSample"
        :sample="detailedSample"
        @continue="handleBatchDetailedSample"
      />

      <batch-samples-batch-selection
        v-else-if="step === ModalToBatchSamplesStep.BatchSelection"
        :sample="detailedSample"
        @continue="handleConfirmBatch($event)"
      />

      <batch-samples-batch-confirmation
        v-else-if="step === ModalToBatchSamplesStep.BatchConfirmation"
        :sample="detailedSample"
        :batch="selectedBatch"
        @cancel="handleClose"
        @close="handleClose"
        @requestSamplesListUpdate="handleRequestSamplesListUpdate"
      />
    </modal>

    <incompatible-samples-modal ref="incompatibleSamplesModal" />

    <no-paternity-samples-modal ref="noPaternitySamplesModal" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { ModalToBatchSamplesStep } from '@/enums'
import { isSamplePaternity } from '@/utils/sample-utils'

import BatchSamplesSampleDetails from './BatchSamplesSampleDetails'
import BatchSamplesBatchSelection from './BatchSamplesBatchSelection'
import BatchSamplesBatchConfirmation from './BatchSamplesBatchConfirmation'
import IncompatibleSamplesModal from './IncompatibleSamplesModal'
import NoPaternitySamplesModal from './NoPaternitySamplesModal'

export default {
  name: 'BatchSamples',
  components: {
    BatchSamplesSampleDetails,
    BatchSamplesBatchSelection,
    BatchSamplesBatchConfirmation,
    IncompatibleSamplesModal,
    NoPaternitySamplesModal,
  },
  data() {
    return {
      ModalToBatchSamplesStep,
      title: null,
      step: null,
      detailedSample: null,
      selectedBatch: null,
    }
  },
  computed: {
    ...mapGetters(['selectedSamples']),
    isDisabled() {
      return this.selectedSamples.length === 0
    },
  },
  methods: {
    resetModalParams() {
      this.title = null
      this.step = null
      this.detailedSample = null
      this.selectedBatch = null
    },
    getMnemonicParts(sample) {
      return sample.batch_label?.split('.') ?? []
    },
    compareDestinationByMnemonic(sampleA, sampleB) {
      const [destinationA] = this.getMnemonicParts(sampleA)
      const [destinationB] = this.getMnemonicParts(sampleB)

      return destinationA === destinationB
    },
    comparePackagingByMnemonic(sampleA, sampleB) {
      const [packagingA] = this.getMnemonicParts(sampleA)
      const [packagingB] = this.getMnemonicParts(sampleB)

      return packagingA === packagingB
    },
    containsDivergentSamples(selectedSamples) {
      const [firstSelectedSample] = selectedSamples

      return selectedSamples.some(
        sample =>
          sample.packagingId !== firstSelectedSample.packagingId ||
          !this.compareDestinationByMnemonic(firstSelectedSample, sample) ||
          !this.comparePackagingByMnemonic(firstSelectedSample, sample)
      )
    },
    containsPaternitySamples(selectedSamples) {
      return selectedSamples.some(sample => isSamplePaternity(sample))
    },
    detailSample(sample) {
      this.title = 'Detalhes da amostra'
      this.detailedSample = sample
      this.step = ModalToBatchSamplesStep.SampleDetails

      this.$refs.batchesModal.open()
    },
    handleBatchSelectedSamples() {
      if (this.containsDivergentSamples(this.selectedSamples)) {
        this.$refs.incompatibleSamplesModal.open()
      } else if (this.containsPaternitySamples(this.selectedSamples)) {
        this.$refs.noPaternitySamplesModal.open()
      } else {
        this.title = 'Selecione o lote'
        this.step = ModalToBatchSamplesStep.BatchSelection

        this.$refs.batchesModal.open()
      }
    },
    handleBatchDetailedSample() {
      this.title = 'Selecione o lote'
      this.step = ModalToBatchSamplesStep.BatchSelection
    },
    handleConfirmBatch(batch) {
      this.title = null
      this.selectedBatch = batch
      this.step = ModalToBatchSamplesStep.BatchConfirmation
    },
    async handleClose() {
      await this.$refs.batchesModal.close()

      this.title = null
      this.detailedSample = null
      this.step = ModalToBatchSamplesStep.SampleDetails
    },
    handleRequestSamplesListUpdate() {
      this.$emit('requestSamplesListUpdate')
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/../static/stylesheets/variables' as *;

:deep(.standard-modal__title) {
  color: $theme-primary-color;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  padding-top: 0.25rem;
}

:deep(.md-dialog) {
  min-width: auto !important;
  width: fit-content !important;
  max-width: none !important;
}

.md-button {
  height: 40px;
}
</style>
